// extracted by css-extract-rspack-plugin
export default {"tooltip":"PublishButton_tooltip__teOH8"};